/* global Office */

import { FORBO_MAIL_PROPERTY } from "../constants/forbo";
import { ForboIcon } from "../types/models";
import { toSecureIconUrl } from "../utils/iconUrls";

export async function insertIcons(icons: ForboIcon[]): Promise<boolean> {
  try {
    if (icons.length === 0) {
      return false;
    }

    const validIcons = icons.filter((icon) => Boolean(icon.icon && icon.uri));
    if (validIcons.length === 0) {
      return false;
    }

    const item = Office.context.mailbox.item;
    if (!item) {
      return false;
    }

    const html = validIcons
      .map((icon) => {
        const width = icon.w || 88;
        const height = icon.h || 88;

        return `<a href="${icon.uri}"><img src="${toSecureIconUrl(icon.icon)}" width="${width}" height="${height}" style="vertical-align:middle;" /></a>&nbsp;`;
      })
      .join("");

    return new Promise((resolve) => {
      item.body.setSelectedDataAsync(
        html,
        {
          coercionType: Office.CoercionType.Html,
        },
        async (result) => {
          if (result.status !== Office.AsyncResultStatus.Succeeded) {
            resolve(false);
            return;
          }

          const tagged = await tagEmailAsForboMail(item);
          resolve(tagged);
        }
      );
    });
  } catch {
    return false;
  }
}

async function tagEmailAsForboMail(item: Office.MessageCompose | Office.AppointmentCompose): Promise<boolean> {
  return new Promise((resolve) => {
    try {
      item.loadCustomPropertiesAsync((result) => {
        if (result.status === Office.AsyncResultStatus.Failed) {
          resolve(false);
          return;
        }

        const customProps = result.value;
        customProps.set(FORBO_MAIL_PROPERTY, "true");

        customProps.saveAsync((saveResult) => {
          resolve(saveResult.status === Office.AsyncResultStatus.Succeeded);
        });
      });
    } catch {
      resolve(false);
    }
  });
}
